export function normalizeReporterId(rawId, now = new Date()) {
  const input = String(rawId || '').trim();
  if (!input) return '';

  if (/^RRN-\d{2}-\d{3}$/i.test(input)) {
    return input.toUpperCase();
  }

  const yy = String(now.getFullYear()).slice(-2);
  const digits = (input.match(/\d/g) || []).join('');

  let seq;
  if (digits.length >= 3) {
    seq = digits.slice(-3);
  } else if (digits.length > 0) {
    seq = digits.padStart(3, '0');
  } else {
    const sum = input.split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
    seq = String(sum % 1000).padStart(3, '0');
  }

  return `RRN-${yy}-${seq}`;
}

export function getLetterUniqueId(reporterId, now = new Date()) {
  const normalized = normalizeReporterId(reporterId, now);
  if (normalized) return normalized;

  const yy = String(now.getFullYear()).slice(-2);
  const seq = String((now.getMilliseconds() + Math.floor(Math.random() * 900)) % 1000).padStart(3, '0');
  return `RRN-${yy}-${seq}`;
}
